<script setup>

const props = defineProps({
    automation: {
        type: Object,
        required: true,
    }
})

</script>

<template>
    <div>
        <div>
            <input-text
                :label="_mft('communication:composer.subjectLine')"
                v-model:content="automation.email_template.subject"
                placeholder="Subject"
            ></input-text>
            <div class="flex justify-between items-center">
                <input-label :label="_mft('communication:composer.previewText')"></input-label>
                <span class="text-gray-500 text-xs">{{ automation.email_template.preview_text?.length || 0 }}/50</span>
            </div>
            <input-textarea
                v-model:content="automation.email_template.preview_text"
                :maxlength="50"
                placeholder="Preview text"
            ></input-textarea>
        </div>
    </div>
</template>

<style scoped>

</style>
